import { ComputedAnswerItem } from '~/src/store/modules/exam-answer/types';
import { OFetchRequestOptions, useOFetch } from '../../../requests';
import { CustomFetchContext } from '../../../requests/types';
import { ApiResponse } from '../../../types';
import {
  UserCollectionListResponse,
  CollectionProgressResponse,
  UserCollectionReportResponse,
} from './types';

// 获取收藏列表
export const fetchCollectionList = async (
  query: {
    userSubject: string; // 末级科目id
    today: string; // 1 今日, 0 全部
    answerType?: string; // 题目类型
    startUpdateTime?: string; //录入时间开始时间戳
    endUpdateTime?: string; //录入时间结束时间戳
    pageSize: number; // 分页
    page: number;
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<UserCollectionListResponse>> => {
  return await useOFetch<UserCollectionListResponse>(
    '/collection/list',
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};

// 移除收藏
export const removeCollection = async (
  body: {
    qid?: string[];
    isAll?: number;
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<string>> => {
  return await useOFetch<string>(
    '/collection/remove',
    {
      method: 'POST',
      body,
      ...options,
    },
    fetchContext
  );
};

// 提交收藏作答
export const submitCollection = async (
  body: {
    qid: string[];
    isAll?: number;
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<string>> => {
  return await useOFetch<string>(
    '/collection/remove',
    {
      method: 'POST',
      body,
      ...options,
    },
    fetchContext
  );
};

// 保存进度 collection/save-progress
export const saveCollectionProgress = async (
  body: {
    answer: ComputedAnswerItem[];
    userSubject: string; //末级科目id
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<string>> => {
  return await useOFetch<string>(
    '/collection/save-progress',
    {
      body,
      method: 'POST',
      ...options,
    },
    fetchContext
  );
};

// 获取进度 collection/get-progress
export const getCollectionProgress = async (
  query: {
    userSubject: string; //末级科目id
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<CollectionProgressResponse>> => {
  return await useOFetch<CollectionProgressResponse>(
    '/collection/get-progress',
    {
      query,
      method: 'POST',
      ...options,
    },
    fetchContext
  );
};

export const submitUserCorrection = async (
  body: {
    answer: string;
    userSubject: string;
    examTime: number;
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<string>> => {
  return await useOFetch<string>(
    '/collection/submit',
    {
      method: 'POST',
      body,
      ...options,
    },
    fetchContext
  );
};

// 收藏报告
export const fetchUserCollectReport = async (
  query: {
    userSubject: string;
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<UserCollectionReportResponse>> => {
  return await useOFetch<UserCollectionReportResponse>(
    '/collection/report',
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};
